export default "__VITE_ASSET__Df$fdIw2__"